import baseApi from "../../lib/baseApi";
import { DonationPayload, PaymentResponse, StripePaymentStartResponse } from "../../types/payment/paymentTypes";

// Create a donation — for both authenticated and anonymous users ----------------
export const createDonationApi = async (data: DonationPayload): Promise<PaymentResponse> => {
  const response = await baseApi.post("/payment/donations/create-donation/", data);
  return response.data;
};

// Get details of a donation (for checkout UI) ------------------------------------
export const getDonationPaymentDetailsApi = async (
  donationId: number
): Promise<PaymentResponse> => {
  const response = await baseApi.get(`/payment/donations/${donationId}/`);
  return response.data;
};

// Update an existing donation ---------------------------------------------------
export const updateDonationApi = async (
  donationId: number,
  data: DonationPayload
): Promise<PaymentResponse> => {
  const response = await baseApi.patch(`/payment/donations/${donationId}/`, data);
  return response.data;
};





// ✅ Start PayPal Payment -------------------------------------------------------
export const startPaymentApi = async (
  paymentId: number,
  email?: string
): Promise<{ approval_url: string }> => {
  const payload = email ? { email } : {};
  const response = await baseApi.post(`/payment/process/${paymentId}/start-payment/`, payload);
  return response.data;
};

// Cancel a donation payment -----------------------------------------------------
export const cancelPaymentApi = async (paymentId: number): Promise<{ message: string }> => {
  const response = await baseApi.post(`/payment/process/${paymentId}/cancel-payment/`);
  return response.data;
};

// Get details of a Payment (for checkout UI) ------------------------------------
export const getPaymentDetailsApi = async (
  paymentId: number
): Promise<PaymentResponse> => {
  const response = await baseApi.get(`/payment/process/${paymentId}/details/`);
  return response.data;
};

// ✅ Confirm PayPal Payment
export const confirmPaymentApi = async (
  paymentId: number,
  paymentIdPaypal: string,
  payerId: string
): Promise<{ status: string }> => {
  const response = await baseApi.get(
    `/payment/process/${paymentId}/confirm-payment/?paymentId=${paymentIdPaypal}&PayerID=${payerId}`
  );
  return response.data;
};

// ✅ Reject PayPal Payment
export const rejectPaymentApi = async (
  paymentId: number,
  cancelToken?: string
): Promise<{ status: string }> => {
  const url = cancelToken
    ? `/payment/process/${paymentId}/reject-payment/?cancel_token=${cancelToken}`
    : `/payment/process/${paymentId}/reject-payment/`;

  const response = await baseApi.post(url);
  return response.data;
};

// ✅ Retry Payment by Reference Number
export const retryPaymentByRefApi = async (
  referenceNumber: string
): Promise<{
  id: number;
  reference_number: string;
  type: string;
  status: string;
}> => {
  const response = await baseApi.post(`/payment/process/by-ref/${referenceNumber}/retry-payment/`);
  return response.data;
};

// ✅ Start Stripe Payment
export const startStripePaymentApi = async (
  paymentId: number
): Promise<StripePaymentStartResponse> => {
  const response = await baseApi.post(`/payment/process/${paymentId}/start-stripe-payment/`);
  return response.data;
};

